const omittedUrls = ["/public/public-results", "/results-report"];

export function isAllowedRoute(pathname) {
  return !omittedUrls.some((url) => pathname.startsWith(url));
}
